import { render, staticRenderFns } from "./PriceFormat.vue?vue&type=template&id=23bdfec6&scoped=true&"
import script from "./PriceFormat.vue?vue&type=script&lang=js&"
export * from "./PriceFormat.vue?vue&type=script&lang=js&"
import style0 from "./PriceFormat.vue?vue&type=style&index=0&id=23bdfec6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bdfec6",
  null
  
)

export default component.exports